export default __webpack_public_path__ + "static/media/illustration_avatar.fa325ee7.png";